{
  "longPressMessage": "Nyomja meg hosszan az előnézet megnyitásához"
}
